export default __webpack_public_path__ + "static/media/Check.e92a4162.svg";